import React, { useEffect, useState } from 'react';

const fetchChangelog = async (): Promise<string> => {
  const response = await fetch('/CHANGELOG.md');
  return response.text();
};

export const ChangelogViewer: React.FC = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetchChangelog().then(setContent).catch(() => false);
  }, []);

  return (
    <div style={{ margin: '0 auto', padding: '2rem' }}>
      <pre>{content}</pre>
    </div>
  );
};
